<div class="tw-flex tw-flex-col tw-flex-1">

  <sb-mega-navbar
    class="tw-shrink-0 sm:tw-h-20 tw-h-14"
    [user]="userService?.user"
    [logoLink]="'home'"
    [navPoints]="navpointsService.navMain"
    [permissionCallback]=permissionService.hasUserPermissions>

    <ul class="navbar__wrapper__navbar__nav" navbar-content>
      <li *ngIf="permissionService.hasPermission(permissionService.Permission.device_export) && reports?.length > 0" class="nav-item
      navbar__wrapper__navbar-hoverbg">
        <div [autoClose]="true" class="d-inline-block" ngbDropdown placement="bottom-right">
          <a class="nav-link" ngbDropdownToggle>
            <div class="pulse pulse-danger">
              <sb-icon class="bell-ring" icon="pieChartList"></sb-icon>
              <span class="show rounded-pill-empty red-bg"></span>
              <span class="pulse-ring" style="right: -14px;top: -16px;"></span>
            </div>
            <sb-icon style="font-size: 0.5rem" icon="chevronDown"></sb-icon>
          </a>
          <div ngbDropdownMenu style="width: 370px; border-radius: 6px;">
            <sb-comp-generated-reports-list></sb-comp-generated-reports-list>
          </div>
        </div>
      </li>
      <!--
  <li *ngPermissions="permissionService.Permission.notification_list" class="nav-item navbar__wrapper__navbar-hoverbg">
  <div [autoClose]="true" class="d-inline-block" ngbDropdown placement="bottom-right">
  <a class="nav-link" ngbDropdownToggle>
    <div [ngClass]="notificationsAlerts ? 'pulse pulse-danger' : ''">
      <sb-icon [ngClass]="{'bell-ring': newNotifications}" icon="bell"></sb-icon>
      <ng-container *ngIf="notificationService.totalPendingNotificationsCount > 0">
        <span [ngClass]="{'show' : notificationsAlerts}" class="rounded-pill-empty red-bg"></span>
        <span class="pulse-ring" style="right: -14px;top: -16px;"></span>
      </ng-container>
    </div>
    <sb-icon style="font-size: 0.5rem" icon="chevronDown"></sb-icon>
  </a>
  <div ngbDropdownMenu style="width: 370px; border-radius: 6px;">
    <sb-notification-list></sb-notification-list>
  </div>
  </div>
  </li>
      -->
      <!-- discussion feature
          <li *ngPermissions="[permissionService.Permission.discussion_list]"
              [ngClass]="{'navbar__wrapper__navbar__nav-active' : discussionService.showDiscussionSideBar}"
              class=" tw-hidden sm:tw-flex nav-item navbar__wrapper__navbar-hoverbg">
            <a (click)="toggleSideBar()" class="nav-link">
              <sb-icon class="tw-block tw-m-0 !tw-text-[150%]" icon="discussionsFilled"></sb-icon>
            </a>
          </li>
          -->
      @if (kiService.isServiceConnected() && permissionService.hasPermission(permissionService.Permission.ai_access)) {
        <li
          [ngClass]="{'navbar__wrapper__navbar__nav-active' : kiService.showKIPanel}"
          class=" tw-flex nav-item navbar__wrapper__navbar-hoverbg">
          <a (click)="kiService.toggleKIPanel()" class="nav-link">
            <sb-icon class="tw-block !tw-m-0" icon="discussionsFilled"></sb-icon>
          </a>
        </li>
      }

      <li class="nav-item navbar__wrapper__navbar-hoverbg tw-ml-2 tw-my-2"
          [ngStyle]="{'border': userService?.selectedCompany?.value? '4px solid #3E7CB1': ''}">
        <div class="tw-inline-flex">
          <a (click)="showCompanySelectModal()" class="nav-link" ngbTooltip="{{'lang.globals.customer' | translate}}" container="body"
             placement="bottom">
            <sb-icon icon="companySwitch" class="!tw-m-0"></sb-icon>
          </a>
        </div>
        <div *ngIf="userService?.selectedCompany?.value"
             class="tw-px-2 tw-flex tw-items-center">
          <div>
            {{ userService?.selectedCompany?.value?.name }}
          </div>
          <sb-icon icon="error" class="tw-m-0 tw-mx-2 tw-cursor-pointer !tw-text-[150%] tw-text-sbGray-500"
                   (click)="userService.selectedCompany.next(null); saveCompanyToSessionStorage(null)"></sb-icon>
        </div>

        <sb-level-dropdown (clickedAction)="resolveDropdownAction($event)" [dropdown]="userMenu" class="tw-mr-2" placement="right"
                           [ngStyle]="{'border-left': userService?.selectedCompany?.value ? '1px solid #b7bdc6':''}">
          <a class="nav-link !tw-p-0 tw-h-full tw-ml-3">
            <div class="userContainer tw-hidden sm:tw-flex">
              <div class="userContainer__details">
                <div class="userContainer__details__username">{{ userService?.user?.user.name }}</div>
                <div class="userContainer__details__companyname">{{ userService?.user?.client?.name }}</div>
              </div>
              <div [style.backgroundImage]="companyAvatar?'url('+companyAvatar+')': ''" class="userContainer__picBg">
              </div>
            </div>
            <div class="tw-block sm:tw-hidden">
              <sb-icon class="!tw-m-0 !tw-p-0" icon="user"></sb-icon>
            </div>
          </a>
          <div dropdown-header>
            <div class="userContainer tw-w-full tw-justify-between">
              <div class="userContainer__details">
                <div class="userContainer__details__username">{{ userService?.user?.user.name }}</div>
                <div class="userContainer__details__companyname">{{ userService?.user?.user?.email }}</div>
              </div>
              <div [style.backgroundImage]="avatar?'url('+avatar+')':''" class="userContainer__picBg">
              </div>
            </div>
          </div>

          <div dropdown-footer class="tw-w-full">
            <div class="tw-flex tw-justify-between">
              <div class="btn btn-group no-border tw-mr-1 tw-p-0">
                <button (click)="switchToPrimaryClient(userService?.user?.user?.primaryClient)"
                        [disabled]="!userService?.user?.user?.primaryClient || userService?.user?.user?.primaryClient?.id === userService?.user?.client?.id"
                        [openDelay]="1000" class="btn btn-info btn-sm" container="body"
                        ngbTooltip="{{'lang.globals.switchTo' | translate}}: {{userService?.user?.user?.primaryClient?.name}}">
                  <sb-icon class="tw-m-0" icon="companyClient"></sb-icon>
                </button>
                <button (click)="showClients()"
                        class="btn btn-primary btn-sm tw-h-full">{{ 'lang.home.switchClient' |translate }}
                </button>
              </div>
              <button (click)="signOut()" [openDelay]="1000" class="btn btn-danger btn-sm no-border"
                      container="body" ngbTooltip="{{'lang.home.signOut' | translate}}">
                <sb-icon icon="logOut" class="tw-m-0"></sb-icon>
              </button>
            </div>
          </div>
        </sb-level-dropdown>
      </li>

    </ul>
  </sb-mega-navbar>

  <div class="sm:tw-mx-5 tw-mx-3.5 tw-shrink-0">
    <!--
    <div (@slideInOut.done)="discussionService.animationCompleted=true"
         (@slideInOut.start)="discussionService.animationCompleted=false"
         *ngIf="discussionService.showDiscussionSideBar"
         [@slideInOut]
         class="sidebar-container tw-overflow-hidden">
      <sb-discussion-component *ngPermissions="[permissionService.Permission.discussion_list]"></sb-discussion-component>
    </div>
    -->
    @if (kiService.showKIPanel) {
      <div (@slideInOutKI.done)="kiService.animationCompleted=true"
           (@slideInOutKI.start)="kiService.animationCompleted=false"
           [@slideInOutKI]
           class="sidebar-container-ki overflow-hidden">
        <sb-comp-ki></sb-comp-ki>
      </div>
    }
    <sb-scroll-top-button></sb-scroll-top-button>
    <div class="tw-flex tw-flex-wrap tw-items-center tw-py-6">
      <div class="tw-w-1/2">
        <sb-breadcrumb></sb-breadcrumb>
      </div>
      <div class="tw-w-1/2 tw-justify-end tw-flex tw-text-xl">
        <sb-page-action></sb-page-action>
      </div>
    </div>
  </div>
  <!-- main content -->
  <main class="tw-flex-1 tw-min-h-[500px] sm:tw-mx-5 tw-mx-3.5 sm:tw-mb-5 tw-mb-3.5">
    <router-outlet></router-outlet>
  </main>

  <sb-footer class="tw-shrink-0 tw-h-11 " classes="tw-overflow-hidden tw-relative santa--hover">
    <div footer-bottom class="tw-flex tw-items-center tw-text-xs">
      @if (isChristmas()) {
        <div class="christmas">
          <div *ngFor="let snow of snowArray" class="snow"></div>
        </div>
        <img class="santa" src="assets/img/santa.png" alt="santa image">
      }
      <div class="adplacer_logo__footer tw-mr-3"></div>
      <a (click)="showBackendChangelog()">
        {{ getBackendName() }} {{ getBackendVersion() ?? '???' }}
      </a>
      ||
      <a (click)="showFrontendChangelog()">
        {{ getFrontendName() }} {{ getFrontendVersion() ?? '???' }}
      </a>
    </div>
  </sb-footer>
</div>
